/**
 * WorkshopDetailEyebrow — single shared eyebrow row above every
 * workshop detail page hero.
 *
 *   [← Back to all workshops]  ─────────  [Live, hands-on training ~]
 *
 * - Centered (max-width 800, mx-auto).
 * - Back link: charcoal text + charcoal arrow.
 * - Connecting rule: 1px charcoal line, flex-grow-1 between the two ends.
 * - Right label + wavy mark: terra.
 * - Mobile (≤640px): full "Back to all workshops" collapses to "Back",
 *   right label collapses to just the wavy mark.
 */
import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { WavyMark } from "@/components/ui/wavy-mark";

const TERRA = "var(--terra)";

export function WorkshopDetailEyebrow() {
  return (
    <div
      className="flex items-center gap-3 sm:gap-4 w-full"
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      {/* LEFT — back link, charcoal */}
      <Link
        href="/workshops"
        className="inline-flex items-center gap-1.5 shrink-0 text-charcoal hover:opacity-70 transition-opacity"
        data-testid="link-back-to-workshops"
      >
        <ArrowLeft className="w-3.5 h-3.5" aria-hidden="true" />
        <span className="hidden sm:inline">Back to all workshops</span>
        <span className="sm:hidden">Back</span>
      </Link>

      {/* MIDDLE — black hairline that fills the space between the two ends */}
      <span
        aria-hidden="true"
        className="flex-1 min-w-[24px]"
        style={{
          height: 1,
          backgroundColor: "var(--charcoal)",
          opacity: 0.4,
        }}
      />

      {/* RIGHT — label + wavy mark, terra */}
      <span
        className="inline-flex items-center gap-2 shrink-0"
        style={{ color: TERRA }}
      >
        <span className="hidden sm:inline">Live, hands-on training</span>
        <span style={{ display: "inline-flex" }} aria-hidden="true">
          <WavyMark size={14} />
        </span>
      </span>
    </div>
  );
}
